import { ScheduleType } from '~/domain/PermanentJobs/enums/ScheduleType';

/**
 * Available benefits options for job postings
 */
export const benefitsOptions = [
  { code: 'Health Insurance', name: 'Health Insurance' },
  { code: 'Paid time off', name: 'Paid time off' },
  { code: '401(k)', name: '401(k)' },
  { code: 'Vision Insurance', name: 'Vision Insurance' },
  { code: 'Flexible Schedule', name: 'Flexible Schedule' },
  { code: 'Dental Insurance', name: 'Dental Insurance' },
  { code: 'Other', name: 'Other' },
];

/**
 * Schedule type options for job postings
 */
export const scheduleTypeOptions = [
  { code: ScheduleType.FULL_TIME, name: 'Full Time' },
  { code: ScheduleType.PART_TIME, name: 'Part Time' },
  { code: ScheduleType.FLEXIBLE, name: 'Flexible' },
];

/**
 * Expected days options for job postings
 * Code represents day of week (0 = Sunday, 1 = Monday, etc.)
 */
export const expectedDaysOptions = [
  { code: 1, name: 'Monday' },
  { code: 2, name: 'Tuesday' },
  { code: 3, name: 'Wednesday' },
  { code: 4, name: 'Thursday' },
  { code: 5, name: 'Friday' },
  { code: 6, name: 'Saturday' },
  { code: 0, name: 'Sunday' },
];

/**
 * Maximum length for job title
 */
export const jobTitleMaxLength = 50;

/**
 * Minimum length for job description
 */
export const jobDescriptionMinLength = 150;

/**
 * Maximum length for benefits other field
 */
export const benefitsOtherMaxLength = 100;

export function formatListingFee(price: number): string {
  return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
}
